import { fetchAutomotivePipelineSources } from "./automotiveSourceControls";

const DEFAULT_INTERVAL_MS = 3000;
const DEFAULT_MAX_ATTEMPTS = 120;

export function pollAutomotiveIngestUntilComplete(sourceCode, options = {}) {
  const {
    intervalMs = DEFAULT_INTERVAL_MS,
    maxAttempts = DEFAULT_MAX_ATTEMPTS,
    onUpdate,
    signal,
  } = options;

  return new Promise((resolve, reject) => {
    if (!sourceCode) {
      reject(new Error("sourceCode is required for polling"));
      return;
    }

    let attempts = 0;
    let timerId = null;
    let consecutiveErrors = 0;

    const cleanup = () => {
      if (timerId) {
        clearInterval(timerId);
        timerId = null;
      }
    };

    const poll = async () => {
      if (signal?.aborted) {
        cleanup();
        reject(new Error("Polling cancelled"));
        return;
      }

      attempts += 1;

      try {
        const data = await fetchAutomotivePipelineSources();
        const source = (data?.sources || []).find(
          (item) => item.sourceCode === sourceCode || item.sourceKey === sourceCode
        );

        if (!source) {
          consecutiveErrors += 1;
        } else {
          consecutiveErrors = 0;
          onUpdate?.(source);

          if (!source.isRunning) {
            cleanup();
            resolve(source);
            return;
          }
        }
      } catch (error) {
        consecutiveErrors += 1;

        if (consecutiveErrors >= 3) {
          cleanup();
          reject(error);
          return;
        }
      }

      if (attempts >= maxAttempts) {
        cleanup();
        reject(new Error("Automotive ingestion polling timed out before completion."));
      }
    };

    poll();
    timerId = setInterval(poll, intervalMs);

    if (signal) {
      signal.addEventListener(
        "abort",
        () => {
          cleanup();
          reject(new Error("Polling cancelled"));
        },
        { once: true }
      );
    }
  });
}
